import React from "react";
import { motion } from "framer-motion";
import { RESUME_URL } from "../lib/data";
import { Download } from "lucide-react";

export const ResumeCTA = () => {
  return (
    <section data-testid="resume-cta-section" className="py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl bg-primary text-primary-foreground p-10 md:p-16"
        >
          <div
            aria-hidden
            className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full opacity-20"
            style={{ background: "radial-gradient(circle, #fff 0%, transparent 70%)" }}
          />
          <div className="relative z-10 max-w-2xl">
            <p className="overline text-white/70 mb-4">Resume</p>
            <h2 className="font-serif text-3xl md:text-5xl leading-tight">
              Want the full picture? Grab my resume.
            </h2>
            <p className="mt-5 text-white/80 text-lg leading-relaxed">
              A concise, one-look summary of my experience, skills, tools, and education.
            </p>
            <a
              href={RESUME_URL}
              target="_blank"
              rel="noopener noreferrer"
              download
              data-testid="resume-download-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-primary px-6 py-3 text-sm font-medium hover:bg-white/90 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary"
            >
              <Download size={16} /> Download Resume (PDF)
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
